//@ts-nocheck
import { Component, Vue, Watch } from 'vue-property-decorator';

import template from './appointment.vue';
import { ModalState, User, Permission, WorkingDays, WorkingDaysLunch, Serie } from '@/definitions';
import { Action } from '@/store';
import ApiService from '@/services/api.service';

import apiService from '@/services/api.service';
import { readableDate } from '@/utilities';
import { nl, enUS } from 'date-fns/locale';
import { format } from 'date-fns';
import add from 'date-fns/add';
import { Datetime } from 'vue-datetime';

@Component({
  mixins: [template],
  components: {datetime: Datetime }
})
export default class Appointment extends Vue {
  users: User[] = [];
  selectedUser: string = '';
  showUsers: boolean = false;
  endTime: string | null = null;
  joinsLunch: boolean = true;
  type: string = 'once';
  canAddMultiple: boolean = false;
  canAddForUsers: boolean = false;
  collectLunchInfo: boolean = false;
  entireDay: boolean = true;
  customWorkingDays: WorkingDaysLunch = {
    sunday: {
      date: null,
      present: false,
    },
    monday: {
      date: null,
      present: false,
    },
    tuesday: {
      date: null,
      present: false,
    },
    wednesday: {
      date: null,
      present: false,
    },
    thursday: {
      date: null,
      present: false,
    },
    friday: {
      date: null,
      present: false,
    },
    saturday: {
      date: null,
      present: false,
    },
  };
  createSeries = false;
  serie: Serie = {
    endDate: format(add(new Date(), { months: 1 }), 'yyyy-MM-dd'),
  };

  @Watch('$store.state.modal.active')
  async resetComponent() {
    if (this.modal.active) {
      this.getPermissions();
      this.selectedUser = this.user._id;
      this.type = 'once';
      this.endTime =
        this.modal.props.selectableHours && this.modal.props.selectableHours.length
          ? this.modal.props.selectableHours[0]
          : null;

      this.changeEndTime();
      this.resetCustomWorkingDays();
      this.updateOtherDays();
      this.toggleEntireDay();
      this.serie.endDate = format(add(new Date(), { months: 1 }), 'yyyy-MM-dd');
    }

    if (this.$store.getters.TOKEN && this.user.isAdmin && !this.users.length) {
      if (!this.users.length) {
        this.users.push(this.user);
        try {
          this.users = [...this.users, ...(await apiService.getUsers())];
          this.showUsers = true;
        } catch (e) {
          this.showUsers = false;
          this.$Store.dispatch(Action.SHOW_ALERT, {
            text: 'alerts.users.retrieve_error',
            type: 'danger',
          });
        }
      }
    } else {
      this.showUsers = this.user.isAdmin;
    }
  }

  mounted() {
    this.resetComponent();
  }

  resetCustomWorkingDays() {
    this.customWorkingDays = {
      sunday: {
        date: null,
        present: false,
      },
      monday: {
        date: null,
        present: false,
      },
      tuesday: {
        date: null,
        present: false,
      },
      wednesday: {
        date: null,
        present: false,
      },
      thursday: {
        date: null,
        present: false,
      },
      friday: {
        date: null,
        present: false,
      },
      saturday: {
        date: null,
        present: false,
      },
    };
  }

  updateOtherDays() {
    const date = new Date(this.modal.props.date);
    const day = date.getDay();
    const dayName = Object.keys(this.customWorkingDays)[day];

    this.customWorkingDays[dayName].present = true;
    this.customWorkingDays[dayName].date = this.modal.props.date;

    Object.keys(this.customWorkingDays).forEach((workingDay, index) => {
      const newDate = new Date(date);
      newDate.setDate(newDate.getDate() - (day - index));
      this.customWorkingDays[workingDay].date = newDate;
    });
  }

  get modal(): ModalState {
    return this.$Store.state.modal;
  }

  get user(): User {
    return this.$Store.state.user;
  }

  closeModal(): void {
    this.$Store.dispatch(Action.HIDE_MODAL);
  }

  async getPermissions() {
    try {
      const permissions = await ApiService.getPermissions();
      this.canAddMultiple = (permissions.find(
        (p) => p.name === 'MULTIPLE_RESERVATIONS'
      ) as Permission).isEnabled;
      this.canAddForUsers = (permissions.find(
        (p) => p.name === 'CREATE_APPOINTMENT_FOR_USER'
      ) as Permission).isEnabled;
      this.collectLunchInfo = (permissions.find(
        (p) => p.name === 'COLLECT_LUNCH_INFO'
      ) as Permission).isEnabled;
    } catch (e) {
      this.$Store.dispatch(Action.SHOW_ALERT, {
        text: 'alerts.permissions.retrieve_error',
        type: 'danger',
      });
    }
  }

  async addAppointment() {
    try {
      const postOpt = {
        userId: this.selectedUser,
        roomId: this.modal.props.room,
        seatId: this.modal.props.seat,
        dates: [] as Date[],
        startTime: parseInt(this.modal.props.visibleHour.split(':')[0]),
        endTime: +(this.endTime ? this.endTime.split(':')[0] : this.modal.props.visibleHour + 1),
        joinsLunch: this.joinsLunch,
      };

      if (!this.showUsers) {
        delete postOpt.userId;
      }

      const dayOfTheWeek = new Date(this.modal.props.date).getDay();
      const date = new Date(this.modal.props.date + '');
      if (this.type === 'once') {
        postOpt.dates.push(this.modal.props.date);
      } else if (this.type === 'week') {
        let days = 8 - dayOfTheWeek;
        days = days === 8 ? 1 : days;
        postOpt.dates = [...Array(days).keys()].map(
          (i) => new Date(new Date(date).setDate(date.getDate() + i))
        );
      } else if (this.type === 'workweek') {
        const addDays = dayOfTheWeek === 0 ? 1 : dayOfTheWeek === 6 ? 2 : 0;
        const days = [0, 6].includes(dayOfTheWeek) ? 5 : 6 - dayOfTheWeek;
        postOpt.dates = [...Array(days).keys()].map(
          (i) => new Date(new Date(date).setDate(date.getDate() + i + addDays))
        );
      } else if (this.type === 'other') {
        postOpt.dates = Object.values(this.customWorkingDays)
          .filter((item) => item.present)
          .map((item) => item.date);
      }

      if (this.createSeries) {
        const newDates = [];
        for (const originalDate of postOpt.dates) {
          const currentDate = new Date(originalDate);
          currentDate.setHours(12, 0, 0, 0);
          const endDate = new Date(this.serie.endDate);
          endDate.setHours(12, 0, 0, 0);
          
          while (currentDate <= endDate) {
            newDates.push(JSON.parse(JSON.stringify(currentDate)));
            currentDate.setDate(currentDate.getDate() + 7)
          }
        }

        postOpt.dates = newDates
      }

      const appointmentSuccess = await ApiService.postAppointment(postOpt);

      if (appointmentSuccess) {
        const errors: { error: string; date: string }[] = [];
        appointmentSuccess.forEach((appointment: any) => {
          if (Object.keys(appointment).includes('error')) {
            errors.push(appointment);
          }
        });

        this.$Store.dispatch(Action.HIDE_MODAL);
        if (!errors.length) {
          this.$Store.dispatch(Action.SHOW_ALERT, {
            text: 'alerts.appointments.create_success',
            type: 'success',
          });
        } else {
          if (errors.length === 1) {
            const props = {
              starttime: this.modal.props.visibleHour,
              endtime: this.endTime,
              appointment: readableDate(
                this.dateformatToDate(errors[0].date + ''),
                this.$i18n.locale === 'nl' ? nl : enUS
              ),
            };
            this.$Store.dispatch(Action.SHOW_ALERT, {
              text: 'alerts.appointments.create_error_single',
              type: 'warning',
              props,
            });
          } else {
            let firstAppointments = '';
            errors.splice(0, errors.length - 1).forEach((error, i) => {
              if (i === 0) {
                firstAppointments += readableDate(
                  this.dateformatToDate(error.date + ''),
                  this.$i18n.locale === 'nl' ? nl : enUS
                );
              } else {
                firstAppointments += `, ${readableDate(
                  this.dateformatToDate(error.date + ''),
                  this.$i18n.locale === 'nl' ? nl : enUS
                )}`;
              }
            });

            const props = {
              starttime: this.modal.props.visibleHour,
              endtime: this.endTime,
              first_appointments: firstAppointments,
              last_appointment: readableDate(
                this.dateformatToDate(errors[0].date + ''),
                this.$i18n.locale === 'nl' ? nl : enUS
              ),
            };
            this.$Store.dispatch(Action.SHOW_ALERT, {
              text: 'alerts.appointments.create_error_multiple',
              type: 'warning',
              props,
            });
          }
        }
      } else {
        this.$Store.dispatch(Action.SHOW_ALERT, {
          text: 'alerts.appointments.create_error',
          type: 'danger',
        });
      }
    } catch (e) {
      this.$Store.dispatch(Action.SHOW_ALERT, {
        text: 'alerts.appointments.create_error',
        type: 'danger',
      });
    }
  }

  dateformatToDate(date: string): Date {
    const year = +date.substring(0, 4);
    const month = +date.substring(4, 6);
    const day = +date.substring(6, 8);
    return new Date(year, month - 1, day);
  }

  changeEndTime(): void {
    if (
      this.endTime &&
      parseInt(this.endTime.split(':')[0]) <= parseInt(this.modal.props.visibleHour.split(':')[0])
    ) {
      this.endTime = this.selectableHours()[0];
    }
  }

  selectableHours() {
    return this.modal.props.selectableHours.filter(
      (tmpHour: any) =>
        parseInt(tmpHour.split(':')[0]) > parseInt(this.modal.props.visibleHour.split(':')[0])
    );
  }

  toggleEntireDay() {
    if (this.entireDay) {
      this.modal.props.visibleHour = '08:00';
      this.endTime = '17:00';
    }
  }
}
